import React from 'react'

const EtAdminFunnels = () => {
  return (
    <div>EtAdminFunnels</div>
  )
}

export default EtAdminFunnels